export const isObject = (value: any) => {
  return typeof value === 'object' &&
    value !== null &&
    !(value instanceof Array) &&
    !(value instanceof Date) &&
    !(value instanceof File)
}
